<div class="loading-spinner-container" [@fadeInOut]>
  <img 
    src="../../assets/images/Wedges.svg" 
    alt="Loading..."
    class="loading-spinner-image"
  />
</div>
